import { render, staticRenderFns } from "./SimpleAdvanceList.vue?vue&type=template&id=35857e41&scoped=true&"
import script from "./SimpleAdvanceList.vue?vue&type=script&lang=js&"
export * from "./SimpleAdvanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35857e41",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VDivider,VIcon,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35857e41')) {
      api.createRecord('35857e41', component.options)
    } else {
      api.reload('35857e41', component.options)
    }
    module.hot.accept("./SimpleAdvanceList.vue?vue&type=template&id=35857e41&scoped=true&", function () {
      api.rerender('35857e41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Advance/SimpleAdvanceList.vue"
export default component.exports